import { EnvEnum } from 'types/enums.ts'

type GtagEvent = 'fecha_hora_elegida_clic' | 'Thank_you_page'

export type ThankYouPageEventParams = {
  value?: number
  transaction_id?: string
  currency?: string
  items?: Array<{
    item_id?: string
    item_name?: string
    price?: number
    quantity?: number
    item_category?: string
    /** Custom item parameter: what was bought. */
    type?: 'service' | 'course'
  }>
}

export function createGtagScript(
  tag: GtagEvent,
  eventParams?: ThankYouPageEventParams,
) {
  if (ENV.MODE === EnvEnum.PRODUCTION || ENV.MODE === EnvEnum.STAGING) {
    let additionalScript: string | undefined

    if (tag === 'fecha_hora_elegida_clic') {
      additionalScript = `
       gtag('event', 'fecha_hora_elegida_clic', {
          // <event_parameters>
        });
    `
    }

    if (tag === 'Thank_you_page') {
      const params = eventParams
        ? JSON.stringify(eventParams).replace(/</g, '\\u003c')
        : '{}'
      additionalScript = `
        gtag('event', 'Thank_you_page', ${params});
    `
    }

    if (!additionalScript) return

    const gtagByPathnameScript = document.createElement('script')
    gtagByPathnameScript.innerHTML = additionalScript
    document.head.appendChild(gtagByPathnameScript)

    return gtagByPathnameScript
  }
}
